import type { HolterHomeExaminationRequestData } from '@common/validation/customControls/cardiology/holter/holterHomeExaminationRequestSchemas';
import { EpisodeJournalsAddEdit } from '@frontend/components/pages/customControls/utils/v1/episodeJournals/EpisodeJournalsAddEdit';
import { useProcessActivityEditContext } from '@frontend/utils';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';

export function HolterEpisodeAndJournals() {
    const { patient } = usePatientEpisodeCategoryContext();
    const { errors, processActivityId, onChange } = useProcessActivityEditContext<HolterHomeExaminationRequestData>();

    return (
        <EpisodeJournalsAddEdit
            canAdd={true}
            errors={errors}
            isProcessActivity={true}
            onChange={async (episodesAndJournals, validationKeys) => {
                return onChange({ episodesAndJournals }, validationKeys);
            }}
            patient={patient}
            processActivityId={processActivityId}
            variant="outline"
        />
    );
}
